<script setup>
import AppIcon from "./AppIcon.vue";

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  edit: {
    type: Object,
    required: true,
  },
});

const newStory = {
  info: {
    name: "",
    colour: "red",
  },
  cards: {},
};

const newStartCard = {
  description: "Start",
  tags: "",
  paragraphs: [],
  nodeType: "start",
  links: [
    {
      target: "start",
      linkText: "na",
      conditions: [],
      actions: [],
    },
  ],
  editor: {
    left: 100,
    top: 200,
  },
};

const newEndCard = {
  description: "End",
  tags: "",
  paragraphs: [],
  nodeType: "end",
  prevStory: "",
  detourId: "",
  links: [
    {
      target: "end",
      linkText: "na",
      conditions: [],
      actions: [],
    },
  ],
  editor: {
    left: 700,
    top: 200,
  },
};

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}

function addStart(story) {
  let id = "start";
  props.data.stories[story].cards[id] = JSON.parse(
    JSON.stringify(newStartCard)
  );
}

function addEnd(story) {
  let id = "end";
  props.data.stories[story].cards[id] = JSON.parse(JSON.stringify(newEndCard));
}

function addTextKey() {
  let id = uuidv4();
  props.data.loc[id] = {};

  const keys = Object.keys(props.data.loc["na"]);
  keys.forEach((key, index) => {
    props.data.loc[id][key] = "...";
  });
  return id;
}

function addStory(name) {
  let id = uuidv4();
  props.data.stories[id] = JSON.parse(JSON.stringify(newStory));

  let textKey = addTextKey();
  props.data.stories[id].info.name = textKey;

  props.edit.currentStory = id;

  addStart(id);
  addEnd(id);
}

const emit = defineEmits(["set-story", "add-story", "close-win"]);
</script>

<template>
  <div class="basic-window">
    <div class="ui-container" v-if="data">
      <div class="win-header">
        <h3>Storylets</h3>
        <div class="cornerbutton add">
          <button
            @click="addStory()"
            title="Add storylet"
            class="ui-button ui-button-green ui-button-medium ui-cornerbutton-almost"
          >
            <AppIcon name="plus" />
          </button>
          <button
            @click="$emit('close-win')"
            title="Close"
            class="ui-button ui-button-blue ui-button-medium"
          >
            <AppIcon name="xmark" />
          </button>
        </div>
      </div>
      <div class="win-scrollpane">
        <div class="ui-sub-container">
          <div
            class="row ui-form-textinput"
            v-bind:key="index"
            v-for="(story, index) in data.stories"
            :value="index"
          >
            <input
              type="text"
              class="column"
              v-model="data.loc[story.info.name]['en']"
              style="display: inline-block"
            />
            <button
              @click="$emit('set-story', index)"
              title="Switch to storylet"
              class="ui-button column ui-button-blue"
              style="display: inline-block"
            >
              <AppIcon name="folder-open" />
            </button>
            <button
              @click="$emit('set-story', index)"
              title="Delete storylet"
              class="ui-button column ui-button-red"
              style="display: inline-block"
            >
              <AppIcon name="trash-can" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
